module.exports = __webpack_public_path__ + "static/img/c3.f8ee189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c3.png
// module id = Il40
// module chunks = 1